import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  locationId: null,
  companyId: null,
  location: {},
};

const adminSelectedLocationSlice = createSlice({
  name: "adminSelectedLocation",
  initialState,
  reducers: {
    setLocationId(state, action) {
      state.locationId = action.payload;
    },
    setCompanyId(state, action) {
      state.companyId = action.payload;
    },
    setLocationAndCompany(state, action) {
      state.locationId = action.payload.locationId;
      state.companyId = action.payload.companyId;
      state.location = action.payload.location || {};
    },
    setLocation(state, action) {
      state.location = action.payload;
    },
    resetSelection(state) {
      state.locationId = null;
      state.companyId = null;
      state.location = {};
    },
    resetLocation(state) {
      state.locationId = null;
      state.location = {};
    },
  },
});

export const {
  setLocationId,
  setCompanyId,
  setLocationAndCompany,
  resetSelection,
  resetLocation,
  setLocation,
} = adminSelectedLocationSlice.actions;

export const getLocationId = state => state?.adminSelectedLocation?.locationId;
export const getCompanyId = state => state?.adminSelectedLocation?.companyId;
export const getAdminSelectedLocation = state => state?.adminSelectedLocation?.location;

export default adminSelectedLocationSlice.reducer;
